import * as actionTypes from "browse-media/redux/browseMediaActionTypes";

export const addFacetDialogExpandedPublicationYearGroup = group => ({
  type: actionTypes.ADD_FACET_DIALOG_EXPANDED_PUBLICATION_YEAR_GROUP,
  group,
});
export const addFacetDialogSelectedPublicationYear = yearTerm => ({
  type: actionTypes.ADD_FACET_DIALOG_SELECTED_PUBLICATION_YEAR,
  yearTerm,
});
export const addFacetDialogSelectedPublicationYearGroup = group => ({
  type: actionTypes.ADD_FACET_DIALOG_SELECTED_PUBLICATION_YEAR_GROUP,
  group,
});
export const addFacetDialogSelectedTerm = selectedTerm => ({
  type: actionTypes.ADD_FACET_DIALOG_SELECTED_TERM,
  selectedTerm,
});
export const addModulesDrawerDeselectAll = () => ({
  type: actionTypes.ADD_MODULES_DRAWER_DESELECT_ALL,
});
export const addModulesDrawerFilterQueryChanged = filterQuery => ({
  type: actionTypes.ADD_MODULES_DRAWER_FILTER_QUERY_CHANGED,
  filterQuery,
});
export const addModulesDrawerModuleSelected = (selected, moduleId) => ({
  type: actionTypes.ADD_MODULES_DRAWER_MODULE_SELECTED,
  selected,
  moduleId,
});
export const addModulesDrawerModulesLoaded = modules => ({
  type: actionTypes.ADD_MODULES_DRAWER_MODULES_LOADED,
  modules,
});
export const addSelectedModules = () => ({
  type: actionTypes.ADD_SELECTED_MODULES,
});
export const applyAddModulesDrawerFilterQuery = () => ({
  type: actionTypes.APPLY_ADD_MODULES_DRAWER_FILTER_QUERY,
});
export const applyFacetDialogFacet = () => ({
  type: actionTypes.APPLY_FACET_DIALOG_FACET,
});
export const hideAddModulesDrawer = () => ({
  type: actionTypes.HIDE_ADD_MODULES_DRAWER,
});
export const hideFacetDialog = () => ({ type: actionTypes.HIDE_FACET_DIALOG });
export const hideRemoveModulesDrawer = () => ({
  type: actionTypes.HIDE_REMOVE_MODULES_DRAWER,
});
export const limitChange = limit => ({ type: actionTypes.LIMIT_CHANGE, limit });
export const mediaItemsSynced = mediaIds => ({
  type: actionTypes.MEDIA_ITEMS_SYNCED,
  mediaIds,
});
export const mediaSelected = (selected, mediaId) => ({
  type: actionTypes.MEDIA_SELECTED,
  selected,
  mediaId,
});
export const offsetChange = offset => ({
  type: actionTypes.OFFSET_CHANGE,
  offset,
});
export const queryChange = query => ({ type: actionTypes.QUERY_CHANGE, query });
export const removeFacet = facetName => ({
  type: actionTypes.REMOVE_FACET,
  facetName,
});
export const removeFacetDialogExpandedPublicationYearGroup = group => ({
  type: actionTypes.REMOVE_FACET_DIALOG_EXPANDED_PUBLICATION_YEAR_GROUP,
  group,
});
export const removeFacetDialogSelectedPublicationYear = yearTerm => ({
  type: actionTypes.REMOVE_FACET_DIALOG_SELECTED_PUBLICATION_YEAR,
  yearTerm,
});
export const removeFacetDialogSelectedPublicationYearGroup = group => ({
  type: actionTypes.REMOVE_FACET_DIALOG_SELECTED_PUBLICATION_YEAR_GROUP,
  group,
});
export const removeFacetDialogSelectedTerm = selectedTerm => ({
  type: actionTypes.REMOVE_FACET_DIALOG_SELECTED_TERM,
  selectedTerm,
});
export const removeModulesDrawerDeselectAll = () => ({
  type: actionTypes.REMOVE_MODULES_DRAWER_DESELECT_ALL,
});
export const removeModulesDrawerModuleSelected = (selected, moduleId) => ({
  type: actionTypes.REMOVE_MODULES_DRAWER_MODULE_SELECTED,
  selected,
  moduleId,
});
export const removeModulesDrawerModulesLoaded = modules => ({
  type: actionTypes.REMOVE_MODULES_DRAWER_MODULES_LOADED,
  modules,
});
export const removeQuery = () => ({ type: actionTypes.REMOVE_QUERY });
export const removeSelectedModules = () => ({
  type: actionTypes.REMOVE_SELECTED_MODULES,
});
export const search = () => ({ type: actionTypes.SEARCH });
export const searchResultsLoaded = results => ({
  type: actionTypes.SEARCH_RESULTS_LOADED,
  results,
});
export const selectAll = selected => ({
  type: actionTypes.SELECT_ALL,
  selected,
});
export const setFacetDialogSelectedTerms = selectedTerms => ({
  type: actionTypes.SET_FACET_DIALOG_SELECTED_TERMS,
  selectedTerms,
});
export const showAddModulesDrawer = () => ({
  type: actionTypes.SHOW_ADD_MODULES_DRAWER,
});
export const showFacetDialog = facetName => ({
  type: actionTypes.SHOW_FACET_DIALOG,
  facetName,
});
export const showMoreAddModulesDrawerModules = () => ({
  type: actionTypes.SHOW_MORE_ADD_MODULES_DRAWER_MODULES,
});
export const showRemoveModulesConfirmationDialog = show => ({
  type: actionTypes.SHOW_REMOVE_MODULES_CONFIRMATION_DIALOG,
  show,
});
export const showRemoveModulesDrawer = mediaItem => ({
  type: actionTypes.SHOW_REMOVE_MODULES_DRAWER,
  mediaItem,
});
export const showRemoveModulesDrawerForSelections = () => ({
  type: actionTypes.SHOW_REMOVE_MODULES_DRAWER_FOR_SELECTIONS,
});
